import { render } from "./SurveyQuestion3.vue?vue&type=template&id=5fb43e1e"
import script from "./SurveyQuestion3.vue?vue&type=script&lang=js"
export * from "./SurveyQuestion3.vue?vue&type=script&lang=js"

import "./SurveyQuestion3.vue?vue&type=style&index=0&id=5fb43e1e&lang=css"

import exportComponent from "/home/danujaf/development/customer-survey/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__